import get from 'lodash.get';
import { ACTIVITIES_DATA } from '@amplify/instruction-groups';
import { getActivities } from '../../utils/shared/instructionUtils';
import { GRADE } from '../../constants/shared/GradesConstants';
import { SKILLS } from '../../constants/shared/MeasuresConstants';

const {
    KINDERGARTEN,
    FIRST_GRADE,
    SECOND_GRADE,
    THIRD_GRADE,
    FOURTH_GRADE,
    FIFTH_GRADE,
    SIXTH_GRADE,
} = GRADE;

const {
    PHONOLOGICAL_AWARENESS,
    LETTER_SOUNDS,
    DECODING,
    WORD_READING,
    READING_FLUENCY,
    READING_ACCURACY,
    BASIC_COMPREHENSION,
    VOCABO,
    TRC,
} = SKILLS;

const ACTIVITIES_MAPPER = {
    [PHONOLOGICAL_AWARENESS]: {
        [KINDERGARTEN]: [3001],
        [FIRST_GRADE]: [3002],
    },
    [LETTER_SOUNDS]: {
        [KINDERGARTEN]: [3005],
        [FIRST_GRADE]: [3006],
    },
    [DECODING]: {
        [KINDERGARTEN]: [3005],
        [FIRST_GRADE]: [3006],
    },
    [WORD_READING]: {
        [KINDERGARTEN]: [3010],
        [FIRST_GRADE]: [3011],
        [SECOND_GRADE]: [3012],
        [THIRD_GRADE]: [3013],
    },
    [READING_FLUENCY]: {
        [FIRST_GRADE]: [3011],
        [SECOND_GRADE]: [3012],
        [THIRD_GRADE]: [3013],
        [FOURTH_GRADE]: [3014],
        [FIFTH_GRADE]: [3014],
        [SIXTH_GRADE]: [3014],
    },
    [READING_ACCURACY]: {
        [FIRST_GRADE]: [3011],
        [SECOND_GRADE]: [3012],
        [THIRD_GRADE]: [3013],
        [FOURTH_GRADE]: [3014],
        [FIFTH_GRADE]: [3014],
        [SIXTH_GRADE]: [3014],
    },
    [BASIC_COMPREHENSION]: {
        [SECOND_GRADE]: [3022],
        [THIRD_GRADE]: [3023],
        [FOURTH_GRADE]: [3024],
        [FIFTH_GRADE]: [3024],
        [SIXTH_GRADE]: [3024],
    },
    [VOCABO]: {
        [KINDERGARTEN]: [3015],
        [FIRST_GRADE]: [3016],
        [SECOND_GRADE]: [3017],
        [THIRD_GRADE]: [3018],
        [FOURTH_GRADE]: [3019],
        [FIFTH_GRADE]: [3019],
        [SIXTH_GRADE]: [3019],
    },
    [TRC]: {
        [KINDERGARTEN]: [3020],
        [FIRST_GRADE]: [3021],
        [SECOND_GRADE]: [3022],
        [THIRD_GRADE]: [3023],
        [FOURTH_GRADE]: [3024],
        [FIFTH_GRADE]: [3024],
        [SIXTH_GRADE]: [3024],
    },
};

const getDualLanguageActivitiesBySkillGrade = (skill, grade) =>
    getActivities(get(ACTIVITIES_MAPPER, `${skill}.${grade}`, []), ACTIVITIES_DATA);

export default getDualLanguageActivitiesBySkillGrade;
